import { render, staticRenderFns } from "./ElementPeriodResultGrowthTableColumn.vue?vue&type=template&id=c7ebcd2e&scoped=true"
import script from "./ElementPeriodResultGrowthTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementPeriodResultGrowthTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementPeriodResultGrowthTableColumn.vue?vue&type=style&index=0&id=c7ebcd2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ebcd2e",
  null
  
)

export default component.exports